import gsap from 'gsap'
import ScrollToPlugin from 'gsap/ScrollToPlugin'
import ScrollTrigger from 'gsap/ScrollTrigger'
import { lenisScroll } from 'helpers/smooth-scroll'

const chapterProgressBar = {
  el: {
    arrow: {
      container: document.querySelector<HTMLElement>('.chapter-progress-bar__nav-buttons'),
      left: document.querySelector<HTMLButtonElement>('.chapter-progress-bar__button-prev'),
      right: document.querySelector<HTMLButtonElement>('.chapter-progress-bar__button-next'),
    },
    items: document.querySelectorAll<HTMLElement>('.chapter-progress-bar__item'),
    itemsContainer: document.querySelector<HTMLElement>('.chapter-progress-bar__items'),
    line: document.querySelector<HTMLElement>('.chapter-progress-bar__line'),
    subchapters: document.querySelectorAll<HTMLElement>('.ar-subchapter-block'),
  },

  init(): void {
    gsap.registerPlugin(ScrollToPlugin, ScrollTrigger)

    this.handleArrowButtons()
    this.handleHashOnChange()
    this.handleHashOnLoad()
    this.handleLine()
    setTimeout(this.handleNavigation.bind(this), 124)
  },

  handleArrowButtons(): void {
    const scrollTo = (x: string) => {
      gsap.to(this.el.itemsContainer, { scrollTo: { x }, duration: 0.765, ease: 'power4.out' })
    }

    const toggleArrowsVisibility = () => {
      if (this.el.itemsContainer.scrollWidth > this.el.itemsContainer.clientWidth) {
        this.el.arrow.container.classList.remove('hide')
      } else {
        this.el.arrow.container.classList.add('hide')
      }
    }

    this.el.arrow.left.addEventListener('click', () => scrollTo('-=240'))
    this.el.arrow.right.addEventListener('click', () => scrollTo('+=240'))

    toggleArrowsVisibility()
    window.addEventListener('resize', toggleArrowsVisibility)
  },

  handleHashOnChange(): void {
    window.addEventListener('hashchange', (event) => {
      event.preventDefault()

      const decodedHash = decodeURIComponent(window.location.hash.replace('#', ''))

      this.helpers.scrollTo(document.getElementById(decodedHash))
    })
  },

  handleHashOnLoad(): void {
    if (window.location.hash) {
      const decodedHash = decodeURIComponent(window.location.hash.replace('#', ''))
      const offsetPosition = this.helpers.getOffsetPosition(document.getElementById(decodedHash))

      window.scrollTo(0, offsetPosition)

      setTimeout(() => {
        ScrollTrigger.getAll().forEach((trigger) => trigger.refresh())
      }, 123)
    }
  },

  handleLine(): void {
    ScrollTrigger.create({
      animation: gsap.fromTo(this.el.line, { scaleX: 0 }, { ease: 'none', scaleX: 1 }),
      end: '100% 100%',
      scrub: true,
      start: '0% 0%',
      trigger: '.main-ar',
    })
  },

  handleNavigation(): void {
    this.el.items.forEach((item, index) => {
      if (index === 0) {
        item.addEventListener('click', (event) => {
          event.preventDefault()
          this.helpers.scrollTo(document.querySelector<HTMLElement>('.main-ar'))
        })
      }

      item.addEventListener('click', () => {
        const chapterId = item.getAttribute('data-chapter')
        if (chapterId) {
          const chapterElement = document.getElementById(chapterId)
          if (chapterElement) {
            this.helpers.scrollTo(chapterElement)
          }
        }
      })
    })

    this.el.subchapters.forEach((subchapter, index) => {
      ScrollTrigger.create({
        onEnter: () => {
          this.el.items.forEach((item) => {
            item.classList.remove('chapter-progress-bar__item--current')
          })
          this.el.items[index + 1].classList.add('chapter-progress-bar__item--current')
          this.el.items[index + 1].classList.add('chapter-progress-bar__item--visited')
        },
        onLeaveBack: () => {
          this.el.items[index].classList.add('chapter-progress-bar__item--current')
          this.el.items[index + 1].classList.remove('chapter-progress-bar__item--current')
          this.el.items[index + 1].classList.remove('chapter-progress-bar__item--visited')
        },
        start: '0% 80%',
        trigger: subchapter,
      })
    })
  },

  helpers: {
    getOffsetPosition(element: HTMLElement): number {
      const elementPosition = element.getBoundingClientRect().top + window.scrollY
      const topOffset = document.querySelector<HTMLElement>('.header-ar').offsetHeight * 1.4
      const offsetPosition = elementPosition - topOffset

      return offsetPosition
    },
    scrollTo(element: HTMLElement): void {
      const offsetPosition = chapterProgressBar.helpers.getOffsetPosition(element)

      lenisScroll.scrollTo(offsetPosition, {
        duration: 1.234,
        easing: (t) => (t < 0.5 ? 8 * t ** 4 : 1 - (-2 * t + 2) ** 4 / 2),
        force: true,
      })
    },
  },
}

export default chapterProgressBar
